"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _r10SourceLibrary = require("r10-source-library");
var _r10CommonComponents = require("r10-common-components");
var _constants = require("../../constants");
var _useTranslation = _interopRequireDefault(require("../../hooks/useTranslation"));
var _useConfig2 = _interopRequireDefault(require("../../hooks/useConfig"));
var _useProps2 = _interopRequireDefault(require("../../hooks/useProps"));
var _getValueFromJson2 = _interopRequireDefault(require("../../utils/getValueFromJson"));
var _selectors = require("../../selectors");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var WrapperHeader = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & .flex-class {\n    flex-wrap: nowrap;\n  }\n"])));
var BundlePlanDetails = function BundlePlanDetails() {
  var t = (0, _useTranslation.default)();
  var dateFormat = (0, _reactRedux.useSelector)(_selectors.dateFormatSelector);
  var _useConfig = (0, _useConfig2.default)(),
    _useConfig$activePlan = _useConfig.activePlanSchema,
    _useConfig$activePlan2 = _useConfig$activePlan === void 0 ? {} : _useConfig$activePlan,
    DiscountsSection = _useConfig$activePlan2.DiscountsSection,
    _useConfig$activePlan3 = _useConfig$activePlan2.BundlePlanDetailsSection,
    _useConfig$activePlan4 = _useConfig$activePlan3 === void 0 ? {} : _useConfig$activePlan3,
    activeAddons = _useConfig$activePlan4.activeAddons,
    startDate = _useConfig$activePlan4.startDate,
    endDate = _useConfig$activePlan4.endDate,
    lastTopupDate = _useConfig$activePlan4.lastTopupDate;
  var _useProps = (0, _useProps2.default)(),
    language = _useProps.language;
  var activePlanDetails = (0, _reactRedux.useSelector)(function (state) {
    return state[_constants.PKG_NAME].activePlanDetails;
  });
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    detailsData = _useState2[0],
    setDetailsData = _useState2[1];
  (0, _react.useEffect)(function () {
    if (activePlanDetails) {
      var _getValueFromJson;
      setDetailsData([{
        key: 'numberOfAddons',
        value: typeof (0, _getValueFromJson2.default)(activePlanDetails, activeAddons) == 'string' ? undefined : (_getValueFromJson = (0, _getValueFromJson2.default)(activePlanDetails, activeAddons)) === null || _getValueFromJson === void 0 ? void 0 : _getValueFromJson.length,
        testIdTitle: 'plan-card-active-addons-title',
        testIdValue: 'plan-card-active-addons-value'
      }, {
        key: 'start',
        value: (0, _getValueFromJson2.default)(activePlanDetails, startDate) == '' ? undefined : _r10CommonComponents.utils.formatDate("".concat((0, _getValueFromJson2.default)(activePlanDetails, startDate)), dateFormat),
        testIdTitle: 'plan-card-start-date-title',
        testIdValue: 'plan-card-start-date-value'
      }, {
        key: 'end',
        value: (0, _getValueFromJson2.default)(activePlanDetails, endDate) == '' ? undefined : _r10CommonComponents.utils.formatDate("".concat((0, _getValueFromJson2.default)(activePlanDetails, endDate)), dateFormat)
      }, {
        key: 'lastTopupDate',
        value: (0, _getValueFromJson2.default)(activePlanDetails, lastTopupDate) == '' ? undefined : _r10CommonComponents.utils.formatDate("".concat((0, _getValueFromJson2.default)(activePlanDetails, lastTopupDate)), dateFormat),
        testIdTitle: 'plan-card-last-topup-title',
        testIdValue: 'plan-card-last-topup-value'
      }]);
    }
  }, [language]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(WrapperHeader, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    className: "flex-class"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      right: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
    name: "online-form",
    appearance: "primary",
    size: 4,
    group: "system"
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    weight: 3,
    size: 2,
    noMargin: true
  }, t('planInformation')))), detailsData === null || detailsData === void 0 ? void 0 : detailsData.map(function (d, i) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: d.key
    }, d.value != undefined && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
      justify: "between"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
      col: 6
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
      justify: "start"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: 4,
        bottom: 2
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-testid': d.testIdTitle
      },
      size: 2
    }, t(d.key))))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
      col: 6
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
      justify: "end"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: 4,
        bottom: 2
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-testid': d.testIdValue
      },
      size: 2
    }, d.value))))), (i < (detailsData === null || detailsData === void 0 ? void 0 : detailsData.length) - 1 || (DiscountsSection === null || DiscountsSection === void 0 ? void 0 : DiscountsSection.isShown)) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
      noMargin: true
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
      appearance: "secondary",
      noMargin: true
    }))));
  }));
};
var _default = BundlePlanDetails;
exports.default = _default;